import { render, staticRenderFns } from "./CommercialStory.vue?vue&type=template&id=c5705f42"
import script from "./CommercialStory.vue?vue&type=script&lang=js"
export * from "./CommercialStory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports